export const DropdownsValues = {
  dropDownPersonType: {
    Singular: 'PESS',
    Colectiva: 'COLE'
  },

  dropdownDeceasedRelationship: {
    "Outros": "15",
    "UniaoDeFacto": "4",
    "Conjugue": "2",
    "Enteado": "6",
    "ExConjugue": "3",
    "Netos": "7",
    "Pais": "8",
    "Avos": "9",
    "Filhos": "5"
  },

  dropListCauseOfDeath: {
    "Acidente": "AC",
    "AcidenteEmServico": "AS",
    "Doenca": "DO",
    "DoencaProfissional": "DP",
    "Outra": "OU"
  },
  dropListDocuments: {
    "AtestadoJuntaFreguesia": "MPA000",
    "CertidaoNascFalecido": "DPE004",
    "CertidaoNascRequerente": "DPE012",
    "ComprovativoIBAN": "DPE051",
    "ComprovativoRepresLegal": "MDP110",
    "DeclRequerHabilitando": "DEC256",
    "CertidaoIsencaoIRS":"MPR006",
    "DeclarIRS": "MPR003",
    "DeclarComprHonra": "MDP180",
    "DeclarPensaoAlimentos": "DEC253",
    "DeclarPrestSocialInclusao": "MDP190",
    "DocPrestacoesFamiliares": "EBI007",
    "DocComprovativoSegSocial": "MPP041",
    "FaturaOuRecibo": "MPC001",
    "ProvaEfetividade": "MDP170",
    "ProvaEscolar": "MPE000",
    "SentencaHabilJudicial": "MPN004",
    "CertidaoNascReprLegal":"DPE016",
    "OutroMeioProva":"MPO000"
  },
  dropdownRepresentationType: {
    "Judicial":"J",// "EP",
    "Menoridade":"M", // "FI",
    "Procuracao":"P", //"AD"
  },
  dropListMaritalStatus: {
    "SeparadodeFacto": "SF",
    "SeparadoJudicialmente": "SJ",
    "Solteiro": "SO",
    "UniaoDeFacto": "UF",
    "Viuvo": "VI",
    "Divorciado": "DI",
    "Casado": "CA",
    "Ignorado": "IG",
  },
  dropListScholarSituationDeathDate: {
    "AtestadoMedico": "ATM",
    "Frequencia": "FRQ",
    "Matriculado": "MTR",
    "NaoColocado": "NCOL",
  }
  
}
